<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <Button
        size="small"
        type="dashed"
        class="extra-btn"
        @click="goToMore"
        v-if="hasPageAccess('SHOP_AGENT_REPORT')"
      >
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <!-- 门店得分 -->
    <div class="top-line">
      <p>
        <!-- <span class="title">{{ $t('common.store_score') }}</span
        ><Icon
          size="16"
          :title="$t('common.store_score_desc')"
          type="ios-information-circle-outline"
        /> -->
      </p>
      <Select
        v-if="scoringRule == 2"
        v-model="scoringRuleModel"
        :transfer="false"
        style="width: 80px; height: 32px; margin-right: 10px"
        @on-change="sortChange"
      >
        <Option :value="0" key="top">{{ $t('home.score_rate') }}</Option>
        <Option :value="1" key="last">{{ $t('home.actual_score') }}</Option>
      </Select>
      <Select
        v-model="sortWay"
        :transfer="false"
        style="width: 80px; height: 32px"
        @on-change="sortChange"
      >
        <Option :value="0" key="top">TOP</Option>
        <Option :value="1" key="last">LAST</Option>
      </Select>
    </div>
    <div class="content">
      <board-one-item
        v-for="(item, index) in StoreList"
        :key="item.id"
        :storeItem="item"
        :storeIndex="index"
        :currentPage="currentPage"
        color="#FFC82B"
      ></board-one-item>
      <Spin size="large" v-if="isLoading" fix></Spin>
      <div
        v-if="!isLoading && (!StoreList || StoreList.length === 0)"
        class="no-data"
      >
        {{ $t('common.no_data') }}
      </div>
    </div>
    <div style="display: flex; justify-content: space-around; margin-top: 10px">
      <Page
        :total="totalPage"
        :page-size="5"
        :current="currentPage"
        size="small"
        @on-change="changPage"
      />
    </div>
  </Card>
</template>
<script>
import boardOneItem from './boardOneItem.vue';
import api from '../../../api/home/index';
import moment from 'moment';
import { privileageAccess } from '../../../mixins/privileage';
export default {
  mixins: [privileageAccess],
  components: {
    boardOneItem,
  },
  data() {
    return {
      sortWay: 0,
      StoreList: [],
      totalPage: null,
      currentPage: 1,
      isLoading: false,
      scoringRule: 0,
      scoringRuleModel: 0,
    };
  },
  mounted() {
    this.isLoading = true;
    this.changPage(1);
  },
  methods: {
    // 分页
    async changPage(pageNumber) {
      this.isLoading = true;
      let startTime = moment()
        .month(moment().month())
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment()
        .month(moment().month())
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let params = {
        timeType: 3,
        startTime,
        endTime,
        order: this.sortWay,
        pageNumber,
        pageSize: 5,
      };
      const userInfo = this.$system.$state.userInfo;
      let groupId = userInfo && userInfo.groupId ? userInfo.groupId : 0;
      let rule = await api.getReviewConfig({ enterpriseId: groupId });
      this.scoringRule = rule.scoringRule;
      if (this.scoringRule == 2) {
        params.scoringRule = this.scoringRuleModel;
      } else {
        this.scoringRuleModel = this.scoringRule;
        params.scoringRule = this.scoringRule;
      }
      this.pageShopScore(params).then(() => {
        this.currentPage = pageNumber;
      });
    },
    // 排序
    sortChange() {
      this.isLoading = true;
      let startTime = moment()
        .month(moment().month())
        .startOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment()
        .month(moment().month())
        .endOf('month')
        .format('YYYY-MM-DD HH:mm:ss');
      let params = {
        timeType: 3, //月  参考web 对接时后端就让参考的...
        startTime,
        endTime,
        order: this.sortWay,
        pageNumber: 1,
        pageSize: 5,
        scoringRule: this.scoringRuleModel,
      };
      this.pageShopScore(params).then(() => {
        this.currentPage = 1;
      });
    },

    async pageShopScore(param) {
      let newParam = {
        ...param,
      };
      await api
        .getShopRank(newParam)
        .then(data => {
          let max = Math.max(
            ...data.records.map(
              i =>
                i[param.scoringRule == 0 ? 'averageShop' : 'actualScore'] || 0
            )
          );
          let content = data.records.map(i => {
            return {
              name: i.shopName,
              nowScore:
                (i[param.scoringRule == 0 ? 'averageShop' : 'actualScore'] /
                  max) *
                  100 || 0,
              showText:
                i[param.scoringRule == 0 ? 'averageShop' : 'actualScore'],
            };
          });
          this.StoreList = content;
          this.totalPage = data.total;
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.isLoading = false;
        });
    },
    goToMore() {
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_Store_Inspection, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: `/shop-explorer/report/shop-top?timeType=3&scoringRule=${
            this.scoringRule == 2 ? this.scoringRuleModel : this.scoringRule
          }`, //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative !important;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

.content {
  height: 200px;
  .rank-index {
    display: inline-block;
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 6px;
    background: #f0f0f0;
    color: #333333;
    text-align: center;
  }
}
::v-deep {
  .ivu-progress-outer {
    margin-top: 4px;
  }
}
</style>
